import React from 'react';
import { InstalledBadge } from '../installed-badge';
import { PricingBadge } from '../pricing-badge';
import { useEssentials } from '../../contexts/essentials-context';
import { SetupIncompleteBadge } from '../setup-incomplete-badge';
import { PremiumSiteRequiredBadge } from '../premium-site-required-badge';
import { Box, Text } from '@wix/design-system';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
import { appInfoBadgeDataHooks } from './data-hooks';
export function AppInfoBadge({ isAppInstalled, isAppBuiltIn, isAppSetupIncomplete, isAppWithBenefits, pricing, options, dataHook = appInfoBadgeDataHooks.APP_INFO_BADGE, skin = 'default', }) {
    const { t, experiments } = useEssentials();
    const { showPricing = true, showPremiumRequired, size = 'tiny' } = options;
    const replaceInstalledBundleLabel = Boolean(experiments?.enabled('specs.app-market.MoveBundlesToBenefits'));
    let children;
    if (isAppWithBenefits && !isAppInstalled) {
        children = (React.createElement(Text, { size: size, weight: "thin", skin: "success", secondary: true }, t('app.pricing.bundle-free')));
    }
    else if (isAppWithBenefits && isAppInstalled) {
        children = (React.createElement(InstalledBadge, { size: size }, replaceInstalledBundleLabel
            ? t('pricing.label.benefit.installed')
            : t('solutionBox.solutionBottomActionBar.BundleInstalled')));
    }
    else if (showPremiumRequired) {
        children = (React.createElement(PremiumSiteRequiredBadge, { size: size, showIcon: skin === 'default' }));
    }
    else if (isAppBuiltIn) {
        children = (React.createElement(Box, { gap: "4px", verticalAlign: "middle" },
            React.createElement(StatusCompleteFilledSmall, { color: "#60bc57" }),
            React.createElement(Text, { size: size, skin: "success" }, t('solutionBox.solutionBottomActionBar.builtInSolution'))));
    }
    else if (isAppSetupIncomplete) {
        children = (React.createElement(Box, null,
            React.createElement(SetupIncompleteBadge, null)));
    }
    else if (isAppInstalled) {
        children = (React.createElement(InstalledBadge, { size: size }, t('solutionBox.solutionBottomActionBar.installedSolution')));
    }
    else if (showPricing && pricing.label) {
        children = React.createElement(PricingBadge, { size: size, ...pricing });
    }
    else {
        children = null;
    }
    return children ? React.createElement("div", { "data-hook": dataHook }, children) : null;
}
//# sourceMappingURL=app-info-badge.js.map